// Mock data for development - replace with actual API calls
export const mockProductsForOrders = [
  { id: 1, name: 'Product A - Premium Widget', price: 149.99 },
  { id: 2, name: 'Product B - Standard Widget', price: 199.50 },
  { id: 3, name: 'Product C - Deluxe Widget', price: 150.00 },
  { id: 4, name: 'Product D - Basic Widget', price: 89.99 },
  { id: 5, name: 'Product E - Professional Widget', price: 150.05 },
  { id: 6, name: 'Product F - Enterprise Widget', price: 162.87 },
  { id: 7, name: 'Product G - Ultimate Widget', price: 1299.99 },
  { id: 8, name: 'Product H - Starter Widget', price: 89.50 },
  { id: 9, name: 'Product I - Advanced Widget', price: 58.42 },
  { id: 10, name: 'Product J - Elite Widget', price: 2599.99 },
  { id: 11, name: 'Product K - Custom Widget', price: 111.45 },
  { id: 12, name: 'Product L - Special Widget', price: 25.00 },
  { id: 13, name: 'Product M - Limited Widget', price: 339.45 },
  { id: 14, name: 'Product N - Exclusive Widget', price: 78.22 },
  { id: 15, name: 'Product O - Signature Widget', price: 899.99 }
];

// Mock products data for product management
export const mockProducts = [
  {
    id: 1,
    category_id: 1,
    name: "Trina Solar Vertex S+ 540W Mono PERC",
    description: "High-efficiency monocrystalline solar panel with advanced PERC technology. Perfect for residential and commercial installations with excellent performance in low-light conditions.",
    thumbnail_image: "https://via.placeholder.com/300x200/4CAF50/white?text=Solar+Panel",
    original_image: "https://via.placeholder.com/600x400/4CAF50/white?text=Solar+Panel",
    images: [
      "https://via.placeholder.com/400x300/4CAF50/white?text=Image+1",
      "https://via.placeholder.com/400x300/4CAF50/white?text=Image+2",
      "https://via.placeholder.com/400x300/4CAF50/white?text=Image+3"
    ],
    price: 15000.00,
    discount_price: [
      { max: 5, qty: 1, price: 15000 },
      { max: 10, qty: 6, price: 14500 },
      { max: 20, qty: 11, price: 14000 },
      { qty: 21, price: 13500 }
    ],
    warranty: "25 years product warranty, 12 years performance warranty",
    is_featured: true,
    specifications: {
      "Wattage": "540W",
      "Efficiency": "21.2%",
      "Voltage": "49.6V",
      "Current": "10.89A",
      "Cell Type": "Monocrystalline PERC",
      "Frame": "Anodized Aluminum",
      "Glass": "3.2mm Tempered Glass",
      "Dimensions": "2172×1303×35mm",
      "Weight": "27.5kg"
    },
    brand: "Trina Solar",
    active: true,
    wattage: 540,
    sku_code: "TSM-540DE18M",
    created_at: "2024-01-15T10:30:00Z",
    updated_at: "2024-01-15T10:30:00Z"
  },
  {
    id: 2,
    category_id: 1,
    name: "Canadian Solar HiKu7 Mono PERC 665W",
    description: "Ultra-high power solar module with innovative half-cell technology and multi-busbar design for maximum energy yield and reliability.",
    thumbnail_image: "https://via.placeholder.com/300x200/2196F3/white?text=Solar+Panel",
    original_image: "https://via.placeholder.com/600x400/2196F3/white?text=Solar+Panel",
    images: [
      "https://via.placeholder.com/400x300/2196F3/white?text=Image+1",
      "https://via.placeholder.com/400x300/2196F3/white?text=Image+2"
    ],
    price: 18500.00,
    discount_price: [
      { max: 3, qty: 1, price: 18500 },
      { max: 8, qty: 4, price: 18000 },
      { max: 15, qty: 9, price: 17500 },
      { qty: 16, price: 17000 }
    ],
    warranty: "25 years linear power warranty",
    is_featured: false,
    specifications: {
      "Wattage": "665W",
      "Efficiency": "21.4%",
      "Voltage": "46.9V",
      "Current": "14.18A",
      "Cell Type": "Monocrystalline PERC",
      "Frame": "Silver Anodized Aluminum",
      "Glass": "3.2mm Anti-Reflective Tempered Glass",
      "Dimensions": "2384×1303×35mm",
      "Weight": "33.2kg"
    },
    brand: "Canadian Solar",
    active: true,
    wattage: 665,
    sku_code: "CS7L-665MS",
    created_at: "2024-01-14T09:15:00Z",
    updated_at: "2024-01-14T09:15:00Z"
  },
  {
    id: 3,
    category_id: 2,
    name: "Growatt SPF 5000 TL HVM Off-Grid Inverter",
    description: "Advanced off-grid solar inverter with built-in MPPT charge controller, perfect for residential and small commercial applications.",
    thumbnail_image: "https://via.placeholder.com/300x200/FF9800/white?text=Inverter",
    original_image: "https://via.placeholder.com/600x400/FF9800/white?text=Inverter",
    images: [
      "https://via.placeholder.com/400x300/FF9800/white?text=Image+1",
      "https://via.placeholder.com/400x300/FF9800/white?text=Image+2",
      "https://via.placeholder.com/400x300/FF9800/white?text=Image+3",
      "https://via.placeholder.com/400x300/FF9800/white?text=Image+4"
    ],
    price: 45000.00,
    discount_price: [
      { max: 2, qty: 1, price: 45000 },
      { max: 5, qty: 3, price: 43000 },
      { qty: 6, price: 41000 }
    ],
    warranty: "5 years manufacturer warranty",
    is_featured: true,
    specifications: {
      "Power Rating": "5000W",
      "Input Voltage": "120-450VDC",
      "Output Voltage": "230VAC",
      "Efficiency": "93%",
      "MPPT Range": "120-450VDC",
      "Battery Voltage": "48VDC",
      "Display": "LCD Display",
      "Protection": "Over/Under Voltage, Over Current, Short Circuit",
      "Dimensions": "375×670×220mm",
      "Weight": "25kg"
    },
    brand: "Growatt",
    active: true,
    wattage: null,
    sku_code: "SPF-5000TL-HVM",
    created_at: "2024-01-13T14:20:00Z",
    updated_at: "2024-01-13T14:20:00Z"
  },
  {
    id: 4,
    category_id: 2,
    name: "Luminous Solar NXG1800 Hybrid Inverter",
    description: "Smart hybrid solar inverter with advanced battery management system and Wi-Fi monitoring capabilities.",
    thumbnail_image: "https://via.placeholder.com/300x200/9C27B0/white?text=Inverter",
    original_image: "https://via.placeholder.com/600x400/9C27B0/white?text=Inverter",
    images: [
      "https://via.placeholder.com/400x300/9C27B0/white?text=Image+1"
    ],
    price: 28000.00,
    discount_price: [
      { max: 3, qty: 1, price: 28000 },
      { max: 7, qty: 4, price: 27000 },
      { qty: 8, price: 26000 }
    ],
    warranty: "3 years comprehensive warranty",
    is_featured: false,
    specifications: {
      "Power Rating": "1800VA",
      "Input Voltage": "90-290VAC",
      "Output Voltage": "230VAC ±10%",
      "Efficiency": "85%",
      "Battery Type": "Tubular/SMF",
      "Charging Current": "18A",
      "Display": "Digital LCD",
      "Solar Input": "24VDC",
      "Dimensions": "395×185×275mm",
      "Weight": "12kg"
    },
    brand: "Luminous",
    active: true,
    wattage: null,
    sku_code: "NXG1800",
    created_at: "2024-01-12T11:45:00Z",
    updated_at: "2024-01-12T11:45:00Z"
  },
  {
    id: 5,
    category_id: 3,
    name: "MC4 Solar Panel Connector Set",
    description: "High-quality MC4 connectors for secure and weatherproof solar panel connections. IP67 rated for outdoor use.",
    thumbnail_image: "https://via.placeholder.com/300x200/607D8B/white?text=MC4+Connector",
    original_image: "https://via.placeholder.com/600x400/607D8B/white?text=MC4+Connector",
    images: [
      "https://via.placeholder.com/400x300/607D8B/white?text=Image+1",
      "https://via.placeholder.com/400x300/607D8B/white?text=Image+2"
    ],
    price: 150.00,
    discount_price: [
      { max: 10, qty: 1, price: 150 },
      { max: 25, qty: 11, price: 140 },
      { max: 50, qty: 26, price: 130 },
      { qty: 51, price: 120 }
    ],
    warranty: "2 years warranty",
    is_featured: false,
    specifications: {
      "Connector Type": "MC4",
      "Current Rating": "30A",
      "Voltage Rating": "1000VDC",
      "Temperature Range": "-40°C to +90°C",
      "IP Rating": "IP67",
      "Material": "PPO + PA",
      "Contact Material": "Copper, tin plated",
      "Cable Range": "2.5-6.0mm²",
      "Locking System": "Push-in connection"
    },
    brand: "Multi-Contact",
    active: true,
    wattage: null,
    sku_code: "MC4-EVO2",
    created_at: "2024-01-11T16:30:00Z",
    updated_at: "2024-01-11T16:30:00Z"
  },
  {
    id: 6,
    category_id: 3,
    name: "Solar Cable 4mm² DC Wire",
    description: "Premium quality solar DC cable with XLPE insulation, UV resistant and suitable for outdoor installations.",
    thumbnail_image: "https://via.placeholder.com/300x200/795548/white?text=Solar+Cable",
    original_image: "https://via.placeholder.com/600x400/795548/white?text=Solar+Cable",
    images: [],
    price: 85.00,
    discount_price: [
      { max: 100, qty: 1, price: 85 },
      { max: 500, qty: 101, price: 80 },
      { qty: 501, price: 75 }
    ],
    warranty: "25 years UV resistance warranty",
    is_featured: false,
    specifications: {
      "Cable Size": "4mm²",
      "Conductor": "Tinned Copper",
      "Insulation": "XLPE",
      "Jacket": "XLPE",
      "Voltage Rating": "1800VDC",
      "Temperature Rating": "-40°C to +90°C",
      "UV Resistance": "25 years",
      "Flame Retardant": "Yes",
      "Color": "Red/Black"
    },
    brand: "Lapp",
    active: true,
    wattage: null,
    sku_code: "OLFLEX-SOLAR-4",
    created_at: "2024-01-10T13:15:00Z",
    updated_at: "2024-01-10T13:15:00Z"
  },
  {
    id: 7,
    category_id: 1,
    name: "JA Solar JAM72S30 450W Bifacial",
    description: "Innovative bifacial solar panel that generates power from both sides, increasing energy yield by up to 30%.",
    thumbnail_image: "https://via.placeholder.com/300x200/E91E63/white?text=Bifacial+Panel",
    original_image: "https://via.placeholder.com/600x400/E91E63/white?text=Bifacial+Panel",
    images: [
      "https://via.placeholder.com/400x300/E91E63/white?text=Image+1",
      "https://via.placeholder.com/400x300/E91E63/white?text=Image+2",
      "https://via.placeholder.com/400x300/E91E63/white?text=Image+3"
    ],
    price: 16500.00,
    discount_price: [
      { max: 4, qty: 1, price: 16500 },
      { max: 12, qty: 5, price: 16000 },
      { qty: 13, price: 15500 }
    ],
    warranty: "25 years linear power warranty",
    is_featured: true,
    specifications: {
      "Wattage": "450W",
      "Efficiency": "20.7%",
      "Bifaciality": "85%",
      "Voltage": "41.7V",
      "Current": "10.79A",
      "Cell Type": "Monocrystalline PERC",
      "Frame": "Silver Anodized Aluminum",
      "Glass": "2.0mm+2.0mm Tempered Glass",
      "Dimensions": "2172×1303×35mm",
      "Weight": "27kg"
    },
    brand: "JA Solar",
    active: true,
    wattage: 450,
    sku_code: "JAM72S30-450",
    created_at: "2024-01-09T08:45:00Z",
    updated_at: "2024-01-09T08:45:00Z"
  },
  {
    id: 8,
    category_id: 3,
    name: "Solar Mounting Rail 4.2m Aluminum",
    description: "Heavy-duty aluminum mounting rail for secure solar panel installation on various roof types.",
    thumbnail_image: "https://via.placeholder.com/300x200/455A64/white?text=Mounting+Rail",
    original_image: "https://via.placeholder.com/600x400/455A64/white?text=Mounting+Rail",
    images: [
      "https://via.placeholder.com/400x300/455A64/white?text=Image+1"
    ],
    price: 1200.00,
    discount_price: [
      { max: 20, qty: 1, price: 1200 },
      { max: 50, qty: 21, price: 1150 },
      { qty: 51, price: 1100 }
    ],
    warranty: "10 years structural warranty",
    is_featured: false,
    specifications: {
      "Length": "4200mm",
      "Material": "Aluminum 6005-T5",
      "Profile": "40×40mm",
      "Wall Thickness": "2.5mm",
      "Load Capacity": "2400N/m",
      "Surface Treatment": "Anodized",
      "Color": "Silver",
      "Weight": "3.2kg/m",
      "Compatibility": "Universal"
    },
    brand: "Schletter",
    active: true,
    wattage: null,
    sku_code: "SOLO-4200",
    created_at: "2024-01-08T15:20:00Z",
    updated_at: "2024-01-08T15:20:00Z"
  }
];

// Mock data for product pricing with slabs
export const mockProductPricing = [
  {
    pid: 1,
    skuId: 'TSM-540DE18M',
    productName: 'Trina Solar Vertex S+ 540W Mono PERC',
    category_id: 1,
    brand: 'Trina Solar',
    priceSlabs: [
      { max: 5, qty: 1, price: 15000 },
      { max: 10, qty: 6, price: 14500 },
      { max: 20, qty: 11, price: 14000 },
      { qty: 21, price: 13500 }
    ]
  },
  {
    pid: 2,
    skuId: 'CS7L-665MS',
    productName: 'Canadian Solar HiKu7 Mono PERC 665W',
    category_id: 1,
    brand: 'Canadian Solar',
    priceSlabs: [
      { max: 3, qty: 1, price: 18500 },
      { max: 8, qty: 4, price: 18000 },
      { max: 15, qty: 9, price: 17500 },
      { qty: 16, price: 17000 }
    ]
  },
  {
    pid: 3,
    skuId: 'SPF-5000TL-HVM',
    productName: 'Growatt SPF 5000 TL HVM Off-Grid Inverter',
    category_id: 2,
    brand: 'Growatt',
    priceSlabs: [
      { max: 2, qty: 1, price: 45000 },
      { max: 5, qty: 3, price: 43000 },
      { qty: 6, price: 41000 }
    ]
  },
  {
    pid: 4,
    skuId: 'NXG1800',
    productName: 'Luminous Solar NXG1800 Hybrid Inverter',
    category_id: 2,
    brand: 'Luminous',
    priceSlabs: [
      { max: 3, qty: 1, price: 28000 },
      { max: 7, qty: 4, price: 27000 },
      { qty: 8, price: 26000 }
    ]
  },
  {
    pid: 5,
    skuId: 'MC4-EVO2',
    productName: 'MC4 Solar Panel Connector Set',
    category_id: 3,
    brand: 'Multi-Contact',
    priceSlabs: [
      { max: 10, qty: 1, price: 150 },
      { max: 25, qty: 11, price: 140 },
      { max: 50, qty: 26, price: 130 },
      { qty: 51, price: 120 }
    ]
  },
  {
    pid: 6,
    skuId: 'OLFLEX-SOLAR-4',
    productName: 'Solar Cable 4mm² DC Wire',
    category_id: 3,
    brand: 'Lapp',
    priceSlabs: [
      { max: 100, qty: 1, price: 85 },
      { max: 500, qty: 101, price: 80 },
      { qty: 501, price: 75 }
    ]
  },
  {
    pid: 7,
    skuId: 'JAM72S30-450',
    productName: 'JA Solar JAM72S30 450W Bifacial',
    category_id: 1,
    brand: 'JA Solar',
    priceSlabs: [
      { max: 4, qty: 1, price: 16500 },
      { max: 12, qty: 5, price: 16000 },
      { qty: 13, price: 15500 }
    ]
  },
  {
    pid: 8,
    skuId: 'SOLO-4200',
    productName: 'Solar Mounting Rail 4.2m Aluminum',
    category_id: 3,
    brand: 'Schletter',
    priceSlabs: [
      { max: 20, qty: 1, price: 1200 },
      { max: 50, qty: 21, price: 1150 },
      { qty: 51, price: 1100 }
    ]
  }
];

export const mockOrders = [
  {
    id: 'ORD-001',
    customerName: 'John Doe',
    customerEmail: 'john.doe@email.com',
    orderDate: '2024-01-15',
    status: 'pending',
    confirmed: false,
    totalAmount: 299.99,
    items: [
      { id: 1, name: 'Product A', quantity: 2, price: 149.99 }
    ],
    shippingAddress: '123 Main St, Apartment 4B',
    city: 'New York',
    state: 'NY',
    pincode: '10001',
    phone: '+1-555-0123'
  },
  {
    id: 'ORD-002',
    customerName: 'Jane Smith',
    customerEmail: 'jane.smith@email.com',
    orderDate: '2024-01-14',
    status: 'shipped',
    confirmed: true,
    totalAmount: 199.50,
    items: [
      { id: 2, name: 'Product B', quantity: 1, price: 199.50 }
    ],
    shippingAddress: '456 Oak Ave, Suite 12',
    city: 'Los Angeles',
    state: 'CA',
    pincode: '90210',
    phone: '+1-555-0124'
  },
  {
    id: 'ORD-003',
    customerName: 'Bob Johnson',
    customerEmail: 'bob.johnson@email.com',
    orderDate: '2024-01-13',
    status: 'delivered',
    confirmed: true,
    totalAmount: 450.00,
    items: [
      { id: 3, name: 'Product C', quantity: 3, price: 150.00 }
    ],
    shippingAddress: '789 Pine St, Building A',
    city: 'Chicago',
    state: 'IL',
    pincode: '60601',
    phone: '+1-555-0125'
  },
  {
    id: 'ORD-004',
    customerName: 'Alice Brown',
    customerEmail: 'alice.brown@email.com',
    orderDate: '2024-01-12',
    status: 'pending',
    confirmed: false,
    totalAmount: 89.99,
    items: [
      { id: 4, name: 'Product D', quantity: 1, price: 89.99 }
    ],
    shippingAddress: '321 Elm St, City, State 98765',
    phone: '+1-555-0126'
  },
  {
    id: 'ORD-005',
    customerName: 'Charlie Wilson',
    customerEmail: 'charlie.wilson@email.com',
    orderDate: '2024-01-11',
    status: 'confirmed',
    confirmed: true,
    totalAmount: 750.25,
    items: [
      { id: 5, name: 'Product E', quantity: 5, price: 150.05 }
    ],
    shippingAddress: '654 Maple Ave, City, State 13579',
    phone: '+1-555-0127'
  },
  {
    id: 'ORD-006',
    customerName: 'Diana Prince',
    customerEmail: 'diana.prince@email.com',
    orderDate: '2024-01-10',
    status: 'shipped',
    confirmed: true,
    totalAmount: 325.75,
    items: [
      { id: 6, name: 'Product F', quantity: 2, price: 162.87 }
    ],
    shippingAddress: '987 Wonder Ave, City, State 24680',
    phone: '+1-555-0128'
  },
  {
    id: 'ORD-007',
    customerName: 'Bruce Wayne',
    customerEmail: 'bruce.wayne@email.com',
    orderDate: '2024-01-09',
    status: 'pending',
    confirmed: false,
    totalAmount: 1299.99,
    items: [
      { id: 7, name: 'Product G', quantity: 1, price: 1299.99 }
    ],
    shippingAddress: '1007 Mountain Dr, Gotham, State 11111',
    phone: '+1-555-0129'
  },
  {
    id: 'ORD-008',
    customerName: 'Clark Kent',
    customerEmail: 'clark.kent@email.com',
    orderDate: '2024-01-08',
    status: 'delivered',
    confirmed: true,
    totalAmount: 89.50,
    items: [
      { id: 8, name: 'Product H', quantity: 1, price: 89.50 }
    ],
    shippingAddress: '344 Clinton St, Metropolis, State 22222',
    phone: '+1-555-0130'
  },
  {
    id: 'ORD-009',
    customerName: 'Peter Parker',
    customerEmail: 'peter.parker@email.com',
    orderDate: '2024-01-07',
    status: 'confirmed',
    confirmed: true,
    totalAmount: 175.25,
    items: [
      { id: 9, name: 'Product I', quantity: 3, price: 58.42 }
    ],
    shippingAddress: '20 Ingram St, Forest Hills, NY 11375',
    phone: '+1-555-0131'
  },
  {
    id: 'ORD-010',
    customerName: 'Tony Stark',
    customerEmail: 'tony.stark@email.com',
    orderDate: '2024-01-06',
    status: 'shipped',
    confirmed: true,
    totalAmount: 2599.99,
    items: [
      { id: 10, name: 'Product J', quantity: 1, price: 2599.99 }
    ],
    shippingAddress: '10880 Malibu Point, Malibu, CA 90265',
    phone: '+1-555-0132'
  },
  {
    id: 'ORD-011',
    customerName: 'Natasha Romanoff',
    customerEmail: 'natasha.romanoff@email.com',
    orderDate: '2024-01-05',
    status: 'pending',
    confirmed: false,
    totalAmount: 445.80,
    items: [
      { id: 11, name: 'Product K', quantity: 4, price: 111.45 }
    ],
    shippingAddress: '890 Fifth Avenue, New York, NY 10021',
    phone: '+1-555-0133'
  },
  {
    id: 'ORD-012',
    customerName: 'Steve Rogers',
    customerEmail: 'steve.rogers@email.com',
    orderDate: '2024-01-04',
    status: 'delivered',
    confirmed: true,
    totalAmount: 125.00,
    items: [
      { id: 12, name: 'Product L', quantity: 5, price: 25.00 }
    ],
    shippingAddress: '569 Leaman Place, Brooklyn, NY 11201',
    phone: '+1-555-0134'
  },
  {
    id: 'ORD-013',
    customerName: 'Wanda Maximoff',
    customerEmail: 'wanda.maximoff@email.com',
    orderDate: '2024-01-03',
    status: 'confirmed',
    confirmed: true,
    totalAmount: 678.90,
    items: [
      { id: 13, name: 'Product M', quantity: 2, price: 339.45 }
    ],
    shippingAddress: '2800 Ferry Point, Westchester, NY 10573',
    phone: '+1-555-0135'
  },
  {
    id: 'ORD-014',
    customerName: 'Scott Lang',
    customerEmail: 'scott.lang@email.com',
    orderDate: '2024-01-02',
    status: 'shipped',
    confirmed: true,
    totalAmount: 234.67,
    items: [
      { id: 14, name: 'Product N', quantity: 3, price: 78.22 }
    ],
    shippingAddress: '1456 Elm Street, San Francisco, CA 94102',
    phone: '+1-555-0136'
  },
  {
    id: 'ORD-015',
    customerName: 'Carol Danvers',
    customerEmail: 'carol.danvers@email.com',
    orderDate: '2024-01-01',
    status: 'pending',
    confirmed: false,
    totalAmount: 899.99,
    items: [
      { id: 15, name: 'Product O', quantity: 1, price: 899.99 }
    ],
    shippingAddress: '1424 Riviera Drive, Louisiana 70115',
    phone: '+1-555-0137'
  }
];

// Mock API functions
export const getMockOrders = (filters = {}) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      let filteredOrders = [...mockOrders];

      // Apply filters
      if (filters.search) {
        const searchTerm = filters.search.toLowerCase();
        filteredOrders = filteredOrders.filter(order =>
          order.id.toLowerCase().includes(searchTerm) ||
          order.customerName.toLowerCase().includes(searchTerm) ||
          order.customerEmail.toLowerCase().includes(searchTerm) ||
          order.status.toLowerCase().includes(searchTerm)
        );
      }

      if (filters.status && filters.status !== 'all') {
        filteredOrders = filteredOrders.filter(order => order.status === filters.status);
      }

      if (filters.confirmed && filters.confirmed !== 'all') {
        const isConfirmed = filters.confirmed === 'true';
        filteredOrders = filteredOrders.filter(order => order.confirmed === isConfirmed);
      }

      if (filters.dateFrom) {
        filteredOrders = filteredOrders.filter(order => order.orderDate >= filters.dateFrom);
      }

      if (filters.dateTo) {
        filteredOrders = filteredOrders.filter(order => order.orderDate <= filters.dateTo);
      }

      resolve(filteredOrders);
    }, 300); // Simulate API delay
  });
};

export const getMockOrderDetail = (orderId) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const order = mockOrders.find(o => o.id === orderId);
      if (order) {
        resolve(order);
      } else {
        reject(new Error('Order not found'));
      }
    }, 200);
  });
};

export const confirmMockOrder = (orderId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const orderIndex = mockOrders.findIndex(o => o.id === orderId);
      if (orderIndex !== -1) {
        mockOrders[orderIndex].confirmed = true;
        mockOrders[orderIndex].status = 'confirmed';
      }
      resolve(mockOrders[orderIndex]);
    }, 500);
  });
};

export const updateMockOrderStatus = (orderId, status) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const orderIndex = mockOrders.findIndex(o => o.id === orderId);
      if (orderIndex !== -1) {
        mockOrders[orderIndex].status = status;
      }
      resolve(mockOrders[orderIndex]);
    }, 500);
  });
};

export const createMockOrder = (orderData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const newOrder = {
        ...orderData,
        id: orderData.id || `ORD-${Date.now()}`,
        orderDate: orderData.orderDate || new Date().toISOString().split('T')[0]
      };
      
      // Add to mock orders array
      mockOrders.unshift(newOrder);
      
      resolve(newOrder);
    }, 500);
  });
};

export const getMockProductPricing = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(mockProductPricing);
    }, 300);
  });
};

export const updateMockProductPricing = (pid, updatedPriceSlabs) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const productIndex = mockProductPricing.findIndex(p => p.pid === pid);
      if (productIndex !== -1) {
        mockProductPricing[productIndex].priceSlabs = updatedPriceSlabs;
        resolve(mockProductPricing[productIndex]);
      } else {
        throw new Error('Product not found');
      }
    }, 500);
  });
};

// Mock order files data
export const mockOrderFiles = {
  "ORD-1768203371671": [
  {
    id: 1001,
    orderId: "ORD-001",
    fileName: "invoice_ORD-001_2024.pdf",
    fileType: "invoice",
    uploadDate: "2024-01-15T10:30:45Z",
    fileSize: "245 KB",
    uploadedBy: "John Admin",
    fileUrl: "/uploads/orders/ORD-001/invoice_ORD-001_2024.pdf"
  },
  {
    id: 1002,
    orderId: "ORD-001",
    fileName: "shipping_label_fedex.pdf",
    fileType: "shipping",
    uploadDate: "2024-01-16T14:20:30Z",
    fileSize: "156 KB",
    uploadedBy: "Jane Manager",
    fileUrl: "/uploads/orders/ORD-001/shipping_label_fedex.pdf"
  },
  {
    id: 1003,
    orderId: "ORD-001",
    fileName: "customer_signature.jpg",
    fileType: "other",
    uploadDate: "2024-01-17T09:15:22Z",
    fileSize: "89 KB",
    uploadedBy: "Mike Delivery",
    fileUrl: "/uploads/orders/ORD-001/customer_signature.jpg"
  }
]
};

export const getOrderFiles = (orderId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const files = mockOrderFiles[orderId] || [];
      resolve(files);
    }, 300);
  });
};

export const uploadOrderFile = (orderId, fileData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (!mockOrderFiles[orderId]) {
        mockOrderFiles[orderId] = [];
      }
      
      const newFile = {
        id: Date.now(),
        orderId,
        fileName: fileData.fileName,
        fileType: fileData.fileType,
        uploadDate: new Date().toISOString(),
        fileSize: fileData.fileSize,
        uploadedBy: fileData.uploadedBy || 'Current User',
        fileUrl: fileData.fileUrl || '#'
      };
      
      mockOrderFiles[orderId].push(newFile);
      resolve(newFile);
    }, 500);
  });
};

export const deleteOrderFile = (orderId, fileId) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (mockOrderFiles[orderId]) {
        mockOrderFiles[orderId] = mockOrderFiles[orderId].filter(file => file.id !== fileId);
      }
      resolve({ success: true });
    }, 300);
  });
};

export const getMockProductsForOrders = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        data: mockProductsForOrders
      });
    }, 300);
  });
};

// Mock API functions for products
export const getMockProducts = () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        data: mockProducts,
        pagination: {
          current_page: 1,
          total_pages: 1,
          total_items: mockProducts.length,
          items_per_page: 50
        }
      });
    }, 500);
  });
};

export const getMockProductDetail = (productId) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const product = mockProducts.find(p => p.id === parseInt(productId));
      if (product) {
        resolve({
          success: true,
          data: product
        });
      } else {
        reject(new Error('Product not found'));
      }
    }, 300);
  });
};

export const createMockProduct = (productData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const newProduct = {
        id: mockProducts.length + 1,
        ...productData,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };
      
      mockProducts.unshift(newProduct);
      
      resolve({
        success: true,
        data: newProduct,
        message: 'Product created successfully'
      });
    }, 800);
  });
};

export const updateMockProduct = (productId, productData) => {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const productIndex = mockProducts.findIndex(p => p.id === parseInt(productId));
      if (productIndex !== -1) {
        mockProducts[productIndex] = {
          ...mockProducts[productIndex],
          ...productData,
          updated_at: new Date().toISOString()
        };
        
        resolve({
          success: true,
          data: mockProducts[productIndex],
          message: 'Product updated successfully'
        });
      } else {
        reject(new Error('Product not found'));
      }
    }, 600);
  });
};